// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("customer"),
  lock: icon("settings"),
  staff: icon("staff"),
  menuItem: icon('menu'),
  analytics: icon("report"),
  dashboard: icon("dashboard"),
};

const navConfig = [
  // GENERAL
  {
    subheader: "Welcome Back!",
    items: [
      {
        title: "dashboard",
        path: PATH_DASHBOARD.general.app,
        pathList: [PATH_DASHBOARD.general.app],
        icon: ICONS.dashboard,
      },
      // STAFF
      {
        title: "staff",
        path: PATH_DASHBOARD.user.account,
        pathList: [
          PATH_DASHBOARD.user.account,
          PATH_DASHBOARD.user.new,
          PATH_DASHBOARD.user.list,
          PATH_DASHBOARD.user.profile,
          PATH_DASHBOARD.desigination.new,
          PATH_DASHBOARD.user.edit,
          PATH_DASHBOARD.user.replicate,
        ],
        icon: ICONS.staff,
      },

       // MENU
      {
        title: 'menu',
        path: PATH_DASHBOARD.menu.display,
        pathList: [
          PATH_DASHBOARD.menu.display,
          // PATH_DASHBOARD.ingredient.new,
          // PATH_DASHBOARD.ingredient.edit,
          PATH_DASHBOARD.category.new,
          PATH_DASHBOARD.category.edit,
          PATH_DASHBOARD.category.replicate,
          PATH_DASHBOARD.item.new,
          PATH_DASHBOARD.item.edit,
          PATH_DASHBOARD.item.replicate,
          // PATH_DASHBOARD.choice.new,
          // PATH_DASHBOARD.choice.edit,
          // PATH_DASHBOARD.choice.replicate,
          // PATH_DASHBOARD.recipe.new,
          // PATH_DASHBOARD.recipe.edit,
          // PATH_DASHBOARD.recipe.replicate,
        ],
        icon: ICONS.menuItem,
      },

      // REPORTS
      {
        title: "report",
        path: PATH_DASHBOARD.general.report,
        pathList: [PATH_DASHBOARD.general.report],
        icon: ICONS.analytics,
      },

      {
        title: "customers",
        path: PATH_DASHBOARD.customer.list,
        pathList: [
          PATH_DASHBOARD.customer.list,
          PATH_DASHBOARD.customer.edit,
          PATH_DASHBOARD.customer.account,
          PATH_DASHBOARD.customer.profile,
          PATH_DASHBOARD.customer.new,
        ],
        icon: ICONS.user,
      },
      {
        title: "store",
        path: PATH_DASHBOARD.store.themeList,
        pathList: [
          PATH_DASHBOARD.store.themeList,
          PATH_DASHBOARD.store.themePreview(":themeName"),
          PATH_DASHBOARD.store.elementditTheme(":themeName"),
          PATH_DASHBOARD.page.list,
          PATH_DASHBOARD.page.new,
          PATH_DASHBOARD.page.edit,
          PATH_DASHBOARD.page.account,
          PATH_DASHBOARD.page.profile,
        ],
        icon: ICONS.lock,
      },
      {
        title: "settings",
        path: PATH_DASHBOARD.settings.new,
        pathList: [
          PATH_DASHBOARD.settings.new,
          PATH_DASHBOARD.settings.kds,
          PATH_DASHBOARD.settings.edit,
        ],
        icon: ICONS.lock,
      },
    ],
  },
];

export default navConfig;
